export const translations = {
  tr: {
    personalInfo: {
      name: 'Vahit Furkan Bozdemir',
      shortName: 'Vahit Furkan',
      role: 'Sistem & Yazılım Mühendisi',
      tagline: 'Low-Level to Scalable Backend',
      headline: 'Düşük seviyeli sistemlerden güvenli backend mimarilerine.',
      introGreeting: 'Merhaba, ben',
      bio: 'Eskişehir Osmangazi Üniversitesi Bilgisayar Mühendisliği öğrencisiyim. Mikrodenetleyicilerin register ve kesme mimarilerinden Go ve C# ile bellek güvenli, doğrulanmış kriptografik backend servislerine uzanan geniş bir teknik perspektifle sistemler geliştiriyorum.',
      location: 'Eskişehir, Türkiye',
      status: 'Staj & Proje İş Birliklerine Açık',
      focus: 'Backend Mimarileri, Gömülü Sistemler & Kriptografi',
      currentlyBuildingTitle: 'Aktif Mimari & Geliştirme Odağı',
      currentlyBuildingDesc: 'Go & ChaCha20-Poly1305 ile Sıfır Sızıntılı Kasa + PIC16F877A Donanım Protokolleri',
      email: 'vahitfurkanbozdemir0@gmail.com',
      github: 'https://github.com/Wayt-to',
      linkedin: 'https://www.linkedin.com/in/vahit-furkan-bozdemir/',
      emailjs: {
        serviceId: 'service_lbvl52c',
        templateId: 'template_1n90pal',
        publicKey: 'sUquuMPxNl7R-xZWD',
      },
    },
    disciplines: [
      {
        id: 'crypto',
        label: 'CHACHA20 AEAD KRİPTOGRAFİ',
        sublabel: '// Güvenlik & Bellek İzolasyonu',
        title: '256-Bit Doğrulanmış Şifreleme ve Sıfır Veri Sızıntısı',
        desc: 'Go ile geliştirilen, ChaCha20-Poly1305 AEAD algoritması ve bellek güvenli zeroing mekanizmalarıyla çalışan yerel şifreleme kasası.',
        badge: 'GO.AEAD.VAULT',
        link: '#projeler',
      },
      {
        id: 'embedded',
        label: 'BARE-METAL PIC16F',
        sublabel: '// Donanım Register & Kesmeler',
        title: 'Çift PIC16F877A UART Protokolü ve Gerçek Zamanlı Kesmeler',
        desc: 'Master-Slave UART haberleşmesi, Assembly ve C ile donanım register seviyesinde sensör kontrolü ve C# masaüstü izleme paneli.',
        badge: 'PIC16F.UART.SYSTEM',
        link: '#projeler',
      },
      {
        id: 'backend',
        label: 'ÖLÇEKLENEBİLİR BACKEND .NET',
        sublabel: '// Kurumsal & Dağıtık Servisler',
        title: 'Katmanlı ASP.NET MVC, SQL Mimarisi ve Sanal Banka API',
        desc: 'Repository tasarım deseni, dinamik XML ürün ayrıştırma hattı ve kurumsal SQL Server optimizasyonu.',
        badge: 'DOTNET.MVC.SQL',
        link: '#projeler',
      },
      {
        id: 'automata',
        label: 'OTOMAT TEORİSİ DFA',
        sublabel: '// Dil & Ayrıştırma Mühendisliği',
        title: 'Sonlu Durum Makineleri ile Otonom Gereksinim Ayrıştırıcı',
        desc: 'Büyük ölçekli yazılım gereksinim dokümanlarını DFA durum geçiş tablolarıyla tarayan otonom kural motoru.',
        badge: 'DFA.LEXER.CORE',
        link: '#projeler',
      },
      {
        id: 'unreal',
        label: 'UNREAL ENGINE 5 C++',
        sublabel: '// Fizik & İkili Serileştirme',
        title: 'Karakter Hareket Fiziği ve Save-State Serileştirme',
        desc: 'C++ aktör hiyerarşisi, optimize çarpışma algoritmaları ve Save-State ikili serileştirme motoru.',
        badge: 'UE5.CPP.PHYSICS',
        link: '#projeler',
      },
      {
        id: 'community',
        label: 'TOPLULUK LİDERLİĞİ',
        sublabel: '// Ekosistem & Mentörlük',
        title: 'Solana Allstars & Üniversite Konferans Koordinatörlüğü',
        desc: "Eskişehir'in ilk öğrenci blockchain topluluğu liderliği, INOVA 101 programı ve yazılım mentörlüğü.",
        badge: 'COMMUNITY.LEAD',
        link: '#gonulluluk',
      },
    ],
    navLinks: [
      { id: 'projeler', label: 'Projeler' },
      { id: 'yetenekler', label: 'Yetkinlikler' },
      { id: 'gonulluluk', label: 'Gönüllülük' },
      { id: 'egitim', label: 'Eğitim' },
      { id: 'iletisim', label: 'İletişim' },
    ],
    projectCategories: [
      { key: 'all', label: 'Tümü' },
      { key: 'systems', label: 'Sistem & Donanım' },
      { key: 'backend', label: 'Backend & Güvenlik' },
      { key: 'tools', label: 'Araçlar & Oyun' },
    ],
    projects: [
      {
        id: 'vault',
        categoryKey: 'backend',
        categoryLabel: 'Güvenlik & Kriptografi',
        title: 'Client-Side Encryption Vault',
        tagline: 'Go ve ChaCha20-Poly1305 ile Yerel Şifreleme Aracı',
        description:
          'Hassas kullanıcı verilerini yerel ortamda doğrulanmış simetrik şifreleme (AEAD) ile koruyan, bellek güvenliği ve sıfır sızıntı prensiplerine dayalı yerel depolama aracı.',
        highlights: [
          'ChaCha20-Poly1305 AEAD algoritmasıyla 256-bit doğrulanmış şifreleme',
          'Go dilinde bellek güvenli (memory-safe) buffer yönetimi',
          'Hassas anahtarların işlem bitiminde bellekten güvenli imhası (secure zeroing)',
          'Tamamen istemci taraflı (local-first) veri izolasyonu',
        ],
        stack: ['Go', 'ChaCha20-Poly1305', 'AEAD', 'Cryptography', 'Memory Safety'],
        year: '2026',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'embedded-home',
        categoryKey: 'systems',
        categoryLabel: 'Gömülü Sistemler',
        title: 'Integrated Home Automation',
        tagline: 'PIC16F877A Çift Mikrodenetleyici & UART Protokolü',
        description:
          'Master-Slave mimarisinde haberleşen iki adet PIC16F877A mikrodenetleyici tabanlı akıllı ev otomasyonu. Sensör verilerinin register seviyesinde okunması, kesme (interrupt) yönetimi ve C# masaüstü kontrol paneli entegrasyonu.',
        highlights: [
          'PIC16F877A donanım register seviyesinde Assembly ve C ile doğrudan kontrol',
          'Master-Slave UART haberleşme protokolü ve veri paketi doğrulama',
          'Donanım kesmeleri (hardware interrupts) ile gerçek zamanlı veri işleme',
          'C# .NET masaüstü izleme ve yönetim arayüzü',
        ],
        stack: ['Assembly', 'PIC16F877A', 'UART', 'C#', 'Hardware Registers', 'Embedded C'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'pickle-store',
        categoryKey: 'backend',
        categoryLabel: 'Kurumsal Backend',
        title: 'Pickle Store E-Commerce',
        tagline: 'ASP.NET MVC, Dinamik XML Kataloğu & Sanal Banka API',
        description:
          'ASP.NET MVC ve MS SQL Server mimarisi üzerine kurulu uçtan uca e-ticaret platformu. Dinamik XML ürün kataloğu ayrıştırma, sanal banka API entegrasyonu ve WinForms stok/envanter yönetim yazılımı.',
        highlights: [
          'Katmanlı ASP.NET MVC mimarisi ve Repository tasarım deseni',
          'MS SQL Server ilişkisel veritabanı modellemesi ve optimizasyonu',
          'Dinamik XML katalog ingestion ve veri dönüştürme hattı',
          'WinForms tabanlı entegre masaüstü envanter yönetim aracı',
        ],
        stack: ['ASP.NET MVC', 'C#', 'SQL Server', 'XML Parser', 'WinForms', 'Entity Framework'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'reqflow',
        categoryKey: 'tools',
        categoryLabel: 'Dil & Ayrıştırma Mühendisliği',
        title: 'Reqflow Parser',
        tagline: 'Otomat Teorisi Prensipleriyle Otonom Etiket Ayrıştırıcı',
        description:
          'C# ve .NET Core ile geliştirilen, Deterministic Finite Automata (DFA) prensiplerine dayanan metin ayrıştırıcı. Büyük ölçekli yazılım gereksinim dokümanlarını tarayarak yapılandırılmış etiket ve bağımlılık haritaları üretir.',
        highlights: [
          'Sonlu Durum Makineleri (FSM / DFA) mantığıyla durum geçişleri',
          'Stream tabanlı büyük dosya okuma ve bellek dostu tokenization',
          'Gereksinim ID ve bağımlılıklarını otonom çıkaran kural motoru',
        ],
        stack: ['C#', '.NET Core', 'Automata Theory', 'DFA / FSM', 'Lexical Analysis'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'xmas-runner',
        categoryKey: 'tools',
        categoryLabel: '3D Oyun & Dinamikler',
        title: 'Xmas Runner 3D',
        tagline: 'Unreal Engine 5.4 & C++ Tabanlı Fizik Platformu',
        description:
          'Unreal Engine 5.4 motorunda C++ ve Blueprint karma mimarisiyle geliştirilmiş; özel hareket mekanikleri, save-state (durum kaydetme) sistemi ve dinamik çevre etkileşimleri içeren 3D platform oyunu.',
        highlights: [
          'C++ aktör hiyerarşisi ve Blueprint görsel kodlama entegrasyonu',
          'Özel binary serileştirme ile çalışan Save-State motoru',
          'Karakter kontrolörü ve optimize fizik/çarpışma algoritmaları',
        ],
        stack: ['Unreal Engine 5.4', 'C++', 'Blueprints', 'Game Physics', 'Serialization'],
        year: '2024',
        github: 'https://github.com/Wayt-to',
      },
    ],
    capabilities: [
      {
        title: 'Düşük Seviye & Gömülü Sistemler',
        description:
          'PIC mikrodenetleyiciler üzerinde donanım register seviyesinde çalışma, kesme (interrupt) yönetimi, UART haberleşme protokolleri ve kaynak optimizasyonu.',
        technologies: ['PIC16F877A', 'Assembly', 'C/C++', 'UART', 'Registers & Timers', 'Master-Slave'],
      },
      {
        title: 'Ölçeklenebilir Backend & Mimariler',
        description:
          'C#, .NET Core ve Go ile katmanlı ve güvenli servis mimarileri, ilişkisel veritabanı tasarımı, ORM optimizasyonu ve Otomat teorisi tabanlı ayrıştırma algoritmaları.',
        technologies: ['C# / .NET Core', 'ASP.NET MVC', 'Go', 'MS SQL Server', 'Entity Framework', 'Automata / DFA'],
      },
      {
        title: 'Kriptografi & Güvenli Kodlama',
        description:
          'ChaCha20-Poly1305 gibi AEAD standartları ile yerel veri koruma, güvenli bellek temizliği (secure zeroing) ve tehdit modelleme yaklaşımları.',
        technologies: ['ChaCha20-Poly1305', 'AEAD', 'Secure Memory Management', 'Threat Modeling'],
      },
      {
        title: 'Modern Web & İnteraktif Deneyim',
        description:
          'React ile responsive ve erişilebilir kullanıcı arayüzleri, modern CSS mimarisi ve Unreal Engine 5 ile interaktif 3D dinamikler.',
        technologies: ['React.js', 'Responsive CSS', 'Unreal Engine 5', 'RESTful API', 'Git & GitHub'],
      },
    ],
    toolbelt: [
      { category: 'Diller', items: ['C#', 'Go', 'C/C++', 'Assembly', 'JavaScript', 'SQL', 'Python'] },
      { category: 'Framework & Araçlar', items: ['.NET Core', 'ASP.NET MVC', 'React', 'Entity Framework', 'Unreal Engine 5'] },
      { category: 'Donanım & Sistem', items: ['PIC16F877A', 'UART / Seri İletişim', 'Hardware Registers', 'Linux / Windows'] },
      { category: 'Veritabanı & Güvenlik', items: ['MS SQL Server', 'ChaCha20-Poly1305', 'DFA / Lexer', 'AEAD Cryptography'] },
    ],
    leadershipExperiences: [
      {
        role: 'Solana Allstars Koordinatörü',
        organization: 'Solana Allstars Topluluğu',
        period: '2025 — 2026',
        description:
          "Eskişehir'in ilk öğrenci blockchain ve Web3 inisiyatifine liderlik ederek, ekosistem buluşmaları, geliştirici atölyeleri ve teknoloji etkinlikleri düzenledim.",
      },
      {
        role: 'INOVA 101 Koordinatörü',
        organization: 'İnovasyon & Girişimcilik Topluluğu',
        period: '2024 — 2026',
        description:
          'Mühendislik ve yazılım meraklılarını bir araya getiren INOVA 101 programını koordine ederek, sektör profesyonelleri ile öğrencileri buluşturan bilgi paylaşımı oturumları yönettim.',
      },
      {
        role: 'Konferans & Seminer Koordinatörü',
        organization: 'Çeşitli Üniversite Kulüpleri & Öğrenci Toplulukları',
        period: '2024 — Günümüz',
        description:
          'Farklı üniversite kulüpleri ve öğrenci topluluklarında yazılım, siber güvenlik ve kariyer odaklı konferans, seminer ve teknik panellerin uçtan uca organizasyon ve konuşmacı koordinatörlüğünü yürüttüm.',
      },
      {
        role: 'Frontend Geliştirme Mentoru',
        organization: 'Öğrenci Yazılım Kulüpleri',
        period: '2025',
        description:
          'Yazılıma başlayan mühendislik öğrencilerine modern web geliştirme temelleri (React, modern JavaScript ve responsive tasarım) üzerine mentörlük yaptım ve kod incelemeleri gerçekleştirdim.',
      },
    ],
    educationList: [
      {
        period: '2023 — Günümüz',
        degree: 'Lisans',
        field: 'Bilgisayar Mühendisliği',
        institution: 'Eskişehir Osmangazi Üniversitesi',
      },
      {
        period: '2025 — Günümüz',
        degree: 'Lisans (AÖF)',
        field: 'İşletme',
        institution: 'Anadolu Üniversitesi',
      },
      {
        period: '2023 — 2025',
        degree: 'Uzmanlık Sertifikası',
        field: 'Web Yazılım Uzmanlığı',
        institution: 'Eskişehir Bilişim Eğitim',
      },
    ],
    certifications: [
      {
        title: 'Microsoft Certified Professional Developer (MCPD)',
        issuer: 'Microsoft',
      },
      {
        title: 'Cybercamp Siber Güvenlik Eğitimi',
        issuer: 'Cybercamp',
      },
      {
        title: 'Cisco Python Essentials',
        issuer: 'Cisco Networking Academy',
      },
    ],
    ui: {
      interactiveConsoleTitle: '// MİMARİ_TELEMETRİ.EXE',
      exploreSpecimen: 'Detaylı İncele →',
      seeProjects: '→ Projeleri İncele',
      volunteeringLink: '→ Gönüllülük & Liderlik',
      getInTouchLink: '→ İletişime Geç',
      workLabel: 'Mühendislik & Projeler',
      workTitle: 'Seçilmiş Mühendislik Eserleri',
      workSubtitle: 'Düşük seviyeli mikrodenetleyici donanımından, bellek güvenli kriptografik depolama araçlarına ve kurumsal backend servislerine kadar geliştirdiğim çözümler.',
      inspectSource: 'Kaynak Kodu →',
      capabilitiesLabel: 'Mimari & Yetkinlikler',
      capabilitiesTitle: 'Teknik Uzmanlık Alanları',
      capabilitiesSubtitle: 'Donanım katmanından buluta; sistemlerin register düzeyindeki mekaniğinden dağıtık servis mimarilerine kadar her katmanda bilinçli kararlar alıyorum.',
      toolbeltTitle: 'Teknoloji & Mühendislik Araç Seti',
      volunteeringLabel: 'Topluluk & Liderlik',
      volunteeringTitle: 'Gönüllülük Projeleri & İnisiyatifler',
      volunteeringSubtitle: 'Teknoloji topluluklarına liderlik etmek, üniversitelerde konferans ve seminerler koordine etmek ve yazılım atölyeleriyle ekosisteme değer katmak.',
      academicTitle: 'Akademik Geçmiş',
      certsTitle: 'Sertifikalar & Akreditasyon',
      contactLabel: 'İletişim & İş Birliği',
      contactTitle: 'Birlikte Sistemler Geliştirelim',
      contactSubtitle: 'Staj, mühendislik projeleri, backend mimarileri veya teknik konular hakkında konuşmak için bana doğrudan ulaşabilirsiniz.',
      directEmail: 'Doğrudan E-Posta',
      copyEmail: 'E-Postayı Kopyala',
      copied: 'Kopyalandı!',
      openMailClient: 'Mail İstemcisiyle Aç',
      socialsHeading: 'Sosyal Ağlar & Kod Arşivi',
      formName: 'Adınız ve Soyadınız *',
      formEmail: 'E-Posta Adresiniz *',
      formMessage: 'Mesajınız / Proje Detayları *',
      formPlaceholderName: 'Örn: Vahit Furkan Bozdemir',
      formPlaceholderEmail: 'ornek@mail.com',
      formPlaceholderMessage: 'Projeniz veya iletmek istediğiniz detayları buraya yazın...',
      formSuccess: 'Mesajınız başarıyla iletildi! En kısa sürede geri dönüş yapacağım.',
      formError: 'E-posta servisi yanıt vermedi. Aşağıdaki butona tıklayarak mail uygulamanızla gönderebilirsiniz.',
      formSubmit: 'Mesajı Gönder',
      formSending: 'Gönderiliyor...',
      formSendViaMail: 'Mail İle Gönder',
      backToTop: '↑ Başa Dön',
      letsTalk: 'İletişime Geç',
    },
  },
  en: {
    personalInfo: {
      name: 'Vahit Furkan Bozdemir',
      shortName: 'Vahit Furkan',
      role: 'Systems & Software Engineer',
      tagline: 'Low-Level to Scalable Backend',
      headline: 'From low-level register hardware to memory-safe backend architectures.',
      introGreeting: "Hey, I'm",
      bio: 'Computer Engineering student at Eskisehir Osmangazi University. Building robust software across a wide technical spectrum—from microcontroller register-level mechanics to memory-safe, verified cryptographic backend services in Go and C#.',
      location: 'Eskisehir, Turkey',
      status: 'Available for Internships & Projects',
      focus: 'Backend Architectures, Embedded Systems & Cryptography',
      currentlyBuildingTitle: 'Active Architecture & Focus',
      currentlyBuildingDesc: 'Zero-Leakage Cryptographic Vault in Go & ChaCha20-Poly1305 + PIC16F877A Hardware Protocols',
      email: 'vahitfurkanbozdemir0@gmail.com',
      github: 'https://github.com/Wayt-to',
      linkedin: 'https://www.linkedin.com/in/vahit-furkan-bozdemir/',
      emailjs: {
        serviceId: 'service_lbvl52c',
        templateId: 'template_1n90pal',
        publicKey: 'sUquuMPxNl7R-xZWD',
      },
    },
    disciplines: [
      {
        id: 'crypto',
        label: 'CHACHA20 AEAD CRYPTO',
        sublabel: '// Security & Memory Isolation',
        title: '256-Bit Authenticated Encryption & Zero Data Leakage',
        desc: 'Local-first cryptographic vault in Go, utilizing ChaCha20-Poly1305 AEAD and memory-safe key zeroing mechanisms.',
        badge: 'GO.AEAD.VAULT',
        link: '#projeler',
      },
      {
        id: 'embedded',
        label: 'BARE-METAL PIC16F',
        sublabel: '// Hardware Registers & ISR',
        title: 'Dual PIC16F877A UART Protocol & Realtime Interrupts',
        desc: 'Master-Slave UART communication, direct register-level sensor control in Assembly/C, and C# telemetry desktop dashboard.',
        badge: 'PIC16F.UART.SYSTEM',
        link: '#projeler',
      },
      {
        id: 'backend',
        label: 'SCALABLE BACKEND .NET',
        sublabel: '// Enterprise & Distributed',
        title: 'Layered ASP.NET MVC, SQL Schema & Payment Gateway',
        desc: 'Repository pattern architecture, dynamic XML product catalog parsing pipeline, and enterprise SQL query optimization.',
        badge: 'DOTNET.MVC.SQL',
        link: '#projeler',
      },
      {
        id: 'automata',
        label: 'DFA AUTOMATA LEXER',
        sublabel: '// Language & Parsing Theory',
        title: 'Autonomous Requirement Parser using Finite State Machines',
        desc: 'Rule extraction engine parsing large-scale software requirement specifications via Deterministic Finite Automata tables.',
        badge: 'DFA.PARSER.CORE',
        link: '#projeler',
      },
      {
        id: 'unreal',
        label: 'UNREAL ENGINE 5 C++',
        sublabel: '// Physics & Binary Serialization',
        title: 'Locomotion Physics & Custom Binary Save-State System',
        desc: 'C++ actor hierarchies, optimized collision detection, and custom binary state persistence serialization engine.',
        badge: 'UE5.CPP.PHYSICS',
        link: '#projeler',
      },
      {
        id: 'community',
        label: 'COMMUNITY LEADERSHIP',
        sublabel: '// Ecosystem & Mentorship',
        title: 'Solana Allstars & University Conference Coordination',
        desc: "Leading Eskisehir's premier student blockchain community, INOVA 101 innovation program, and engineering mentorship.",
        badge: 'COMMUNITY.LEAD',
        link: '#gonulluluk',
      },
    ],
    navLinks: [
      { id: 'projeler', label: 'Projects' },
      { id: 'yetenekler', label: 'Capabilities' },
      { id: 'gonulluluk', label: 'Volunteering' },
      { id: 'egitim', label: 'Education' },
      { id: 'iletisim', label: 'Contact' },
    ],
    projectCategories: [
      { key: 'all', label: 'All Projects' },
      { key: 'systems', label: 'Systems & Hardware' },
      { key: 'backend', label: 'Backend & Security' },
      { key: 'tools', label: 'Tools & Gaming' },
    ],
    projects: [
      {
        id: 'vault',
        categoryKey: 'backend',
        categoryLabel: 'Security & Cryptography',
        title: 'Client-Side Encryption Vault',
        tagline: 'Local-First Encryption Utility in Go with ChaCha20-Poly1305',
        description:
          'Local data protection tool utilizing authenticated symmetric encryption (AEAD), built upon rigorous memory safety and zero data leakage principles.',
        highlights: [
          '256-bit authenticated encryption using ChaCha20-Poly1305 AEAD',
          'Memory-safe buffer and memory slice allocation in Go',
          'Secure cryptographic key zeroing post-execution to prevent heap inspection',
          'Fully client-side (local-first) threat-modeled data isolation',
        ],
        stack: ['Go', 'ChaCha20-Poly1305', 'AEAD', 'Cryptography', 'Memory Safety'],
        year: '2026',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'embedded-home',
        categoryKey: 'systems',
        categoryLabel: 'Embedded Systems',
        title: 'Integrated Home Automation',
        tagline: 'Dual PIC16F877A Microcontrollers & Master-Slave UART Protocol',
        description:
          'Smart home automation system powered by two PIC16F877A microcontrollers communicating via a custom Master-Slave protocol. Hardware register sensor capture, interrupt handling, and C# desktop dashboard integration.',
        highlights: [
          'Direct hardware register manipulation via Assembly and Embedded C',
          'Master-Slave UART communication protocol with checksum verification',
          'Hardware interrupts for real-time sensor processing and low latency',
          'C# .NET desktop control dashboard and live telemetry monitor',
        ],
        stack: ['Assembly', 'PIC16F877A', 'UART', 'C#', 'Hardware Registers', 'Embedded C'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'pickle-store',
        categoryKey: 'backend',
        categoryLabel: 'Enterprise Backend',
        title: 'Pickle Store E-Commerce',
        tagline: 'ASP.NET MVC, Dynamic XML Ingestion & Bank Payment Gateway API',
        description:
          'End-to-end e-commerce platform built on ASP.NET MVC and MS SQL Server. Features dynamic XML catalog parsing, payment gateway API integration, and an integrated WinForms desktop inventory software.',
        highlights: [
          'Layered ASP.NET MVC architecture with Repository Design Pattern',
          'MS SQL Server relational schema design and query optimization',
          'High-throughput XML product catalog ingestion pipeline',
          'Integrated WinForms desktop inventory management application',
        ],
        stack: ['ASP.NET MVC', 'C#', 'SQL Server', 'XML Parser', 'WinForms', 'Entity Framework'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'reqflow',
        categoryKey: 'tools',
        categoryLabel: 'Language & Parsing',
        title: 'Reqflow Parser',
        tagline: 'Autonomous Requirement Lexer based on Automata Theory',
        description:
          'Text parsing and dependency extraction engine developed in C# and .NET Core based on Deterministic Finite Automata (DFA) theory. Analyzes large-scale software requirement specifications to generate structured tag maps.',
        highlights: [
          'Finite State Machine (FSM / DFA) state-transition processing',
          'Stream-based large document parsing with minimal memory footprint',
          'Autonomous requirement ID and traceability dependency extractor',
        ],
        stack: ['C#', '.NET Core', 'Automata Theory', 'DFA / FSM', 'Lexical Analysis'],
        year: '2025',
        github: 'https://github.com/Wayt-to',
      },
      {
        id: 'xmas-runner',
        categoryKey: 'tools',
        categoryLabel: '3D Game & Dynamics',
        title: 'Xmas Runner 3D',
        tagline: 'Physics Platformer in Unreal Engine 5.4 & C++',
        description:
          '3D platformer game developed in Unreal Engine 5.4 utilizing a hybrid C++ and Blueprint architecture. Includes custom character locomotion, a binary serialization save-state system, and dynamic physics interactions.',
        highlights: [
          'C++ actor hierarchy and Blueprint visual scripting integration',
          'Custom binary serialization engine for fast state persistence',
          'Optimized character controller and custom collision algorithms',
        ],
        stack: ['Unreal Engine 5.4', 'C++', 'Blueprints', 'Game Physics', 'Serialization'],
        year: '2024',
        github: 'https://github.com/Wayt-to',
      },
    ],
    capabilities: [
      {
        title: 'Low-Level & Embedded Systems',
        description:
          'Hardware register programming on PIC microcontrollers, interrupt service routines (ISR), UART protocols, and memory constraint optimization.',
        technologies: ['PIC16F877A', 'Assembly', 'C/C++', 'UART', 'Registers & Timers', 'Master-Slave'],
      },
      {
        title: 'Scalable Backend & Architectures',
        description:
          'Layered, secure backend services in C#, .NET Core, and Go. Relational database modeling, ORM performance tuning, and Automata-based parsing engines.',
        technologies: ['C# / .NET Core', 'ASP.NET MVC', 'Go', 'MS SQL Server', 'Entity Framework', 'Automata / DFA'],
      },
      {
        title: 'Cryptography & Secure Coding',
        description:
          'Client-side data protection using AEAD standards like ChaCha20-Poly1305, secure memory clearing (zeroing), and threat modeling principles.',
        technologies: ['ChaCha20-Poly1305', 'AEAD', 'Secure Memory Management', 'Threat Modeling'],
      },
      {
        title: 'Modern Web & Interactive Systems',
        description:
          'Responsive, accessible UI architectures in React, clean CSS systems, and interactive 3D mechanics in Unreal Engine 5.',
        technologies: ['React.js', 'Responsive CSS', 'Unreal Engine 5', 'RESTful API', 'Git & GitHub'],
      },
    ],
    toolbelt: [
      { category: 'Languages', items: ['C#', 'Go', 'C/C++', 'Assembly', 'JavaScript', 'SQL', 'Python'] },
      { category: 'Frameworks & Tools', items: ['.NET Core', 'ASP.NET MVC', 'React', 'Entity Framework', 'Unreal Engine 5'] },
      { category: 'Hardware & Systems', items: ['PIC16F877A', 'UART / Serial Comms', 'Hardware Registers', 'Linux / Windows'] },
      { category: 'Database & Security', items: ['MS SQL Server', 'ChaCha20-Poly1305', 'DFA / Lexer', 'AEAD Cryptography'] },
    ],
    leadershipExperiences: [
      {
        role: 'Solana Allstars Coordinator',
        organization: 'Solana Allstars Community',
        period: '2025 — 2026',
        description:
          "Led Eskisehir's premier student blockchain and Web3 initiative, organizing ecosystem meetups, developer workshops, and tech conferences.",
      },
      {
        role: 'INOVA 101 Coordinator',
        organization: 'Innovation & Entrepreneurship Society',
        period: '2024 — 2026',
        description:
          'Coordinated the INOVA 101 program uniting engineering and tech enthusiasts, hosting technical knowledge-sharing panels with industry professionals.',
      },
      {
        role: 'Conference & Seminar Coordinator',
        organization: 'Various University Clubs & Student Communities',
        period: '2024 — Present',
        description:
          'Spearheaded end-to-end speaker coordination, logistics, and technical panel moderation across various university societies focused on software, cybersecurity, and engineering careers.',
      },
      {
        role: 'Frontend Development Mentor',
        organization: 'Student Software Societies',
        period: '2025',
        description:
          'Mentored incoming engineering students on modern web development foundations (React, modern JavaScript, and responsive layouts) and conducted code reviews.',
      },
    ],
    educationList: [
      {
        period: '2023 — Present',
        degree: 'Bachelor of Science',
        field: 'Computer Engineering',
        institution: 'Eskisehir Osmangazi University',
      },
      {
        period: '2025 — Present',
        degree: 'Bachelor of Science (OEF)',
        field: 'Business Administration',
        institution: 'Anadolu University',
      },
      {
        period: '2023 — 2025',
        degree: 'Specialist Certificate',
        field: 'Web Software Engineering Specialist',
        institution: 'Eskisehir Bilisim Egitim',
      },
    ],
    certifications: [
      {
        title: 'Microsoft Certified Professional Developer (MCPD)',
        issuer: 'Microsoft',
      },
      {
        title: 'Cybercamp Cybersecurity Training',
        issuer: 'Cybercamp',
      },
      {
        title: 'Cisco Python Essentials',
        issuer: 'Cisco Networking Academy',
      },
    ],
    ui: {
      interactiveConsoleTitle: '// ARCHITECTURE_TELEMETRY.EXE',
      exploreSpecimen: 'Inspect Specimen →',
      seeProjects: '→ See Projects',
      volunteeringLink: '→ Volunteering & Leadership',
      getInTouchLink: '→ Get in Touch',
      workLabel: 'Engineering & Projects',
      workTitle: 'Selected Engineering Work',
      workSubtitle: 'From low-level microcontroller hardware to memory-safe cryptographic vaults and scalable backend enterprise services.',
      inspectSource: 'Inspect Source →',
      capabilitiesLabel: 'Architecture & Capabilities',
      capabilitiesTitle: 'Technical Engineering Domains',
      capabilitiesSubtitle: 'Conscious engineering decisions across all layers—from register mechanics to distributed cloud architectures.',
      toolbeltTitle: 'Engineering & Technology Stack',
      volunteeringLabel: 'Community & Leadership',
      volunteeringTitle: 'Volunteering & Initiatives',
      volunteeringSubtitle: 'Leading developer communities, organizing university conferences, and empowering the ecosystem with technical workshops.',
      academicTitle: 'Academic Background',
      certsTitle: 'Certifications & Credentials',
      contactLabel: 'Contact & Collaboration',
      contactTitle: "Let's Build Systems Together",
      contactSubtitle: 'Reach out directly for internships, engineering projects, backend architectures, or technical discussions.',
      directEmail: 'Direct Email',
      copyEmail: 'Copy Email',
      copied: 'Copied!',
      openMailClient: 'Open Mail Client',
      socialsHeading: 'Socials & Code Archive',
      formName: 'Full Name / Organization *',
      formEmail: 'Email Address *',
      formMessage: 'Message / Project Details *',
      formPlaceholderName: 'e.g. John Doe',
      formPlaceholderEmail: 'name@domain.com',
      formPlaceholderMessage: 'Write your message or project details here...',
      formSuccess: 'Your message has been sent successfully! I will get back to you shortly.',
      formError: 'Email service failed to respond. Click below to send directly via your mail client.',
      formSubmit: 'Send Message',
      formSending: 'Sending...',
      formSendViaMail: 'Send via Mail Client',
      backToTop: '↑ Back to Top',
      letsTalk: "Let's Talk",
    },
  },
};
